import Medication from "./Medication";
export default Medication;